import { Component, OnInit } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ModuloEnum } from '../../../shared/enums/usuario/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/usuario/funcionalidade.enum';
import { PermissaoEnum } from '../../../shared/enums/usuario/permissao.enum';
import { HeaderComponent } from '../../../shared/components/header/header.component';
import { AuthService } from '../../../shared/services/apis/usuario/auth.service';
import { ActionCardComponent } from '../../../shared/components/action-card/action-card.component';

@Component({
  selector: 'app-ferramentas',
  standalone: true,
  imports: [
    RouterModule,
    MatIconModule,
    MatTooltipModule,
    HeaderComponent,
    ActionCardComponent,
  ],
  templateUrl: './ferramentas.component.html',
  styleUrl: './ferramentas.component.css',
})
export class FerramentasComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  public hasPermissaoExportacaoAutomatizada: boolean = false;
  public hasPermissaoMinhasExportacoes: boolean = false;
  public hasPermissaoConfiguracaoIAWhatsapp: boolean = false;

  constructor(private authService: AuthService) {
    this.moduloEnum = ModuloEnum.Home;
    this.funcionalidadeEnum = FuncionalidadeEnum.Home_Ferramentas;
  }

  ngOnInit(): void {
    const userInfos = this.authService.getUserInfos();
    const permissoes = userInfos.listaPermissoes || [];

    this.hasPermissaoExportacaoAutomatizada = permissoes.includes(
      PermissaoEnum.Ferramentas_ExportacaoAutomatizada_Visualizar
    );
    this.hasPermissaoMinhasExportacoes = permissoes.includes(
      PermissaoEnum.Ferramentas_MinhasExportacoes_Visualizar
    );
    this.hasPermissaoConfiguracaoIAWhatsapp = permissoes.includes(
      PermissaoEnum.Ferramentas_ConfiguracaoIAWhatsapp_Visualizar
    );
  }
}
